const rateText = {
	key: `playback.rate`,
	text: "Playback rate {rate}"
};
//#endregion
export { rateText };

//# sourceMappingURL=playback.js.map